import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Button, Col, Collapse, Row } from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import DisabledOrFavoriteQuestionItem from './DisabledOrFavoriteQuestionItem';

class DisabledOrFavoriteQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      questionCountForPaginated: 10,
    };
  }

  resetQuestion = (id) => {
    this.props.resetDisabledIndividualQuestion(id);
  };

  componentWillUnmount() {
    this.props.resetDisabledQuestionObject();
    this.props.resetFavoriteQuestionObject();
    this.props.setDisabledQuestionsCount(0);
    this.props.setFavoriteQuestionsCount(0);
  }

  toggle() {
    this.setState({ show: !this.state.show }, () => {
      if (this.state.show) {
        if (this.props.favorite && this.props.favoriteQuestionsCount === 0) {
          this.props.getFavoriteQuestions(
            this.state.questionCountForPaginated,
            0,
          );
        } else if (
          !this.props.favorite &&
          this.props.disabledQuestionsCount === 0
        ) {
          this.props.getDisabledQuestions(
            this.state.questionCountForPaginated,
            0,
          );
        }
      }
    });
  }

  render() {
    const questions = this.props.favorite
      ? this.props.favoriteQuestions
      : this.props.disabledQuestions;

    const isLoadingQuestions =
      (!this.props.favorite && this.props.isLoadingDisabledQuestions) ||
      (this.props.favorite && this.props.loadingFavoriteQuestions);

    const isMoreQuestions =
      (!this.props.favorite &&
        !this.props.isLoadingDisabledQuestions &&
        this.props.disabledQuestionsCount > questions.length) ||
      (this.props.favorite &&
        !this.props.loadingFavoriteQuestions &&
        this.props.favoriteQuestionsCount > questions.length);

    return (
      <div className="my-profile-component disabled-questions">
        <Row className="header d-flex flex-row justify-content-between">
          <div className="title">{this.props.title}</div>
          {isLoadingQuestions &&
            Array.isArray(questions) &&
            questions.length === 0 && (
              <div className="main-gif-container">
                <CircularLoading
                  height={50}
                  width={50}
                  className="loading-gif-waiting main-gif"
                />
              </div>
            )}
          {Array.isArray(questions) && questions.length > 0 && (
            <button
              className="btn btn-outline-download rounded-lg"
              onClick={() =>
                this.props.favorite
                  ? this.props.removeAllFavoriteQuestions()
                  : this.props.resetAllDisabledQuestions()
              }
            >
              {this.props.favorite
                ? 'Remove all questions'
                : 'Reset all Questions'}
            </button>
          )}
        </Row>

        <Row className="body">
          {!isLoadingQuestions &&
            this.state.show &&
            Array.isArray(questions) &&
            questions.length === 0 && (
              <div className="main-gif-container">
                <span className="no-disabled-questions-text">
                  {this.props.favorite
                    ? 'You have no favorite questions yet'
                    : 'You have no disabled questions yet'}
                </span>
              </div>
            )}

          <Collapse isOpen={this.state.show} className="collapseContainer">
            <Col sm={12} id="questions" ref={this.scrollInfinite}>
              {Array.isArray(questions) && questions.length > 0 && (
                <div className="infiniteScrollContainer">
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() =>
                      this.props.favorite
                        ? this.props.getFavoriteQuestions(
                            this.state.questionCountForPaginated,
                            questions.length,
                          )
                        : this.props.getDisabledQuestions(
                            this.state.questionCountForPaginated,
                            questions.length,
                          )
                    }
                    hasMore={isMoreQuestions}
                    useWindow={false}
                  >
                    {questions.map((question, index) => (
                      <DisabledOrFavoriteQuestionItem
                        key={index}
                        index={index}
                        {...question}
                        resetQuestion={this.resetQuestion}
                        removeFavoriteQuestions={
                          this.props.removeFavoriteQuestions
                        }
                        favorite={this.props.favorite}
                        userId={this.props.userId}
                      />
                    ))}
                  </InfiniteScroll>
                </div>
              )}
            </Col>
          </Collapse>
        </Row>
        <Row className="borderTop">
          <Col sm={12}>
            <Button
              color="link"
              block
              className="link-secondary"
              onClick={() => this.toggle()}
              data-test="show-favorite-question-button"
            >
              {isLoadingQuestions ? (
                <CircularLoading className="loading-gif-waiting load-more-gif" />
              ) : (
                <span>
                  {this.state.show ? 'HIDE QUESTIONS' : 'SHOW QUESTIONS'}
                </span>
              )}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DisabledOrFavoriteQuestions;
